import React, {useEffect, useState} from 'react'
import {Row, Col, Card} from 'react-bootstrap'
import Api from '../../../../../thesis-and-dissertations/helpers/api'

import './style.css'

const api = new Api()

const DashboardCards = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any>({})

  useEffect(() => {
    fetchProfile()
  }, [])

  const fetchProfile = (params = {}) => {
    setLoading(true)
    api
      .getTotalCard({...params})
      .then((response: any) => {
        setLoading(false)
        const data = response.data
        setData(data?.data)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response
      })
  }

  const cards = [
    {
      id: 1,
      icon: 'bi bi-people text-primary',
      value: data?.total_alumni_publik ?? 0,
      label: 'Total Alumni Publik',
      bg: 'rgba(255, 165, 0, 0.1)',
    },
    {
      id: 2,
      icon: 'bi bi-eye',
      value: data?.total_view_mingguan ?? 0,
      label: 'Total View Mingguan',
      note: '',
      noteColor: '',
      bg: '#DBEAFE',
    },
    {
      id: 3,
      icon: 'fa fa-arrow-up text-success',
      value: data?.alumni_terbaru?.nama_lengkap,
      label: 'Terbaru ditambahkan',
      noteColor: 'text-success',
      bg: 'rgba(46, 204, 113, 0.1)',
    },
  ]

  return (
    <div className='my-4'>
      <Row>
        {cards.map((item) => (
          <Col md={4} sm={6} xs={12} key={item.id} className='mb-3'>
            <Card className='shadow-sm border-0 rounded-4 h-100 position-relative overflow-hidden'>
              {/* Dekorasi bulatan di pojok kanan atas */}
              <div
                style={{
                  position: 'absolute',
                  top: '-30px',
                  right: '-30px',
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  backgroundColor: item.bg,
                }}
              />

              <Card.Body>
                {/* Bagian icon + note sejajar */}
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <div
                    className='d-inline-flex align-items-center justify-content-center rounded-3'
                    style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: item.bg,
                    }}
                  >
                    <i className={item.icon} style={{fontSize: '24px'}}></i>
                  </div>
                  {item.note && <p className={`fw-semibold ${item.noteColor}`}>{item.note}</p>}
                </div>

                {/* Angka dan label */}
                <h4 className='fw-bold h4-text'>{item.value}</h4>
                <p className='text-muted mb-0'>{item.label}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default DashboardCards
